/// <reference path="../_references.ts"/>

module App.Helpers {

	interface Scope extends ng.IScope {
		ngModel: string;
	}

	export class CapitalizeDirective implements ng.IDirective {
		public link: (scope:ng.IScope, elm: ng.IAugmentedJQuery, attrs: ng.IAttributes, ctrl:ng.INgModelController) => void;
		public scope = {
			ngModel: '='
		};
		public restrict: string = 'A';
		public require = "ngModel";

		constructor() {

			CapitalizeDirective.prototype.link = (scope: Scope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel: ng.INgModelController) => {
				scope.$watch(() => {
						return ngModel.$modelValue;
					},(current, former) => {
						if (current && former !== current && current !== '') {
							scope.ngModel = scope.ngModel.replace(/^(.)|\s(.)/g, (word: string) => { return word.toUpperCase() });
						}
					}
				);
			};
		}

		public static Factory() {
			let instance = () => {
				return new CapitalizeDirective();
			};


			return instance;
		}
	}

	angular.module('helpers.capitalize', [])
		.directive('capitalize', CapitalizeDirective.Factory());

}